export default __webpack_public_path__ + "static/blob3-1f04ae03b701e866f14e3053424edf2c.svg";